/**
 * IconList section (used for homepage flag section)
 */

import React from "react"
import { Link } from "gatsby"
import parse from "html-react-parser"
import { kebabCase } from "lodash"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import CopyLinkButton from "./copy-link-button"

const IconList = ({ props }) => {
  const { heading, includeInStickyMenu, iconListOptions, leadContent, icons } =
    props
  const cropIcon = iconListOptions.cropIcon
  return (
    <section
      key={heading || includeInStickyMenu?.menuTitle}
      className="section transparent m-section"
    >
      <div className="container">
        <div className="group-copy-link group grid grid-cols-1 justify-start">
          {heading ? (
            <>
              <h2 className="anchor-heading mb-2" id={kebabCase(heading)}>
                {heading}
              </h2>
              <CopyLinkButton heading={heading} />
            </>
          ) : includeInStickyMenu?.menuTitle ? (
            <div id={kebabCase(includeInStickyMenu.menuTitle) || ""}>
              <CopyLinkButton heading={includeInStickyMenu.menuTitle} />
            </div>
          ) : null}
        </div>
        {leadContent ? (
          <div
            className={`max-w-2xl lead-content parsed-content`}
          >
            {parse(leadContent)}
          </div>
        ) : null}
        <ul
          className={`${iconListOptions?.iconSize !== "badge"
            ? "mt-12 mb-20 md:mb-24 2xl:mb-28 grid items-center print:flex print:flex-wrap"
            : ""
            }
              ${iconListOptions?.iconSize === "large"
              ? "grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-8 2xl:gap-12"
              : iconListOptions?.iconSize === "medium"
                ? "grid-cols-2 gap-12 lg:gap-16 xl:gap-x-24 2xl:gap-x-32 mx-auto " +
                (icons?.length === 7 || icons?.length === 8 ? "sm:grid-cols-4" : icons?.length <= 5 ? "sm:grid-cols-5" : "sm:grid-cols-6")
                : iconListOptions?.iconSize === "small"
                  ? "grid-cols-4 md:grid-cols-8 gap-6 lg:gap-8 2xl:gap-12"
                  : iconListOptions?.iconSize === "badge"
                    ? "max-w-full w-80 mx-auto -my-4"
                    : ""
            }`}
        >
          {icons?.map((item, index) => {
            const image = {
              alt: item.icon?.altText || ``,
              publicURL: item.icon?.localFile?.publicURL,
              src: item.icon?.localFile ? getImage(item.icon?.localFile) : null,
              className: `w-full print:w-36 transition-all
              ${item.link ? "hover-grow " : ""}
              ${iconListOptions?.yearList
                  ? "h-0 pb-2/3 rounded-lg"
                  : cropIcon === "circle" || cropIcon === "square"
                    ? "h-0 pb-full"
                    : "h-auto overflow-visible"
                } 
              ${cropIcon === "circle" ? "rounded-full" : ""} 
              ${item.link && iconListOptions?.yearList
                  ? "group-hover:scale-105 hover:scale-105"
                  : item.link || item.label
                    ? "group-focus:opacity-10 group-hover:opacity-10"
                    : ""
                }`,
              objectFit:
                iconListOptions?.yearList ||
                  cropIcon === "circle" ||
                  cropIcon === "cover" ||
                  cropIcon === "square"
                  ? "cover"
                  : "contain",
              imgClassName: `${cropIcon === "circle" ? "rounded-full" : ""}`,
              extension: item.icon?.localFile?.extension,
            }
            return (
              <li className="relative" key={item} data-sal="zoom-out">
                {item.link ? (
                  <Link
                    className={`block group cursor-pointer ${iconListOptions?.yearList ? "rounded-lg" : ""
                      }`}
                    to={item.link.url}
                    target={item.link.target}
                  >
                    <IconListItem
                      item={item}
                      iconListOptions={iconListOptions}
                      image={image}
                    />
                  </Link>
                ) : (
                  <div
                    className={`block group ${iconListOptions?.yearList ? "rounded-lg" : ""
                      }`}
                  >
                    <IconListItem
                      item={item}
                      iconListOptions={iconListOptions}
                      image={image}
                    />
                  </div>
                )}
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

export default IconList

function IconListItem({ item, image, iconListOptions }) {
  return (
    <>
      <span className="sr-only">{item.link?.title || item.label}</span>
      {image?.src && image.extension !== "svg" ? (
        <GatsbyImage
          image={image.src}
          className={image.className}
          objectFit={image.objectFit}
          alt={image.alt}
          imgClassName={image.imgClassName}
        />
      ) : image?.publicURL ? (
        <img
          src={image.publicURL}
          className={image.className}
          alt={image.alt}
        />
      ) : (
        <div className={`${image.className} bg-blue-500`} />
      )}

      {item.link?.title || item.label ? (
        <>
          <div
            className={`text-center leading-tight print:hidden font-bold absolute inset-0 flex transition-all ${iconListOptions?.yearList
              ? "text-white items-end justify-start text-2xl bg-gradient-to-t from-gray-900 px-6 py-3 rounded-lg group-hover:scale-105"
              : "text-black items-center justify-center invisible group-hover:visible group-focus:visible bg-opacity-80"
              } ${iconListOptions.iconSize !== "badge" ? "" : "text-xl"}`}
          >
            {item.link?.title || item.label}
          </div>
          <div className="text-center hidden print:block text-sm">
            {item.link?.title || item.label}
          </div>
        </>
      ) : null}
    </>
  )
}
